import React from 'react'

import { Dialog, useDialogState } from '../../../main/components/dialog'
import { Spinner } from '../../../main/components/spinner'
import { useAsyncModule } from '../../../main/services/async-modules-utils'
import { decodeQueryString } from '../../queryString'
import { saveToPortfolioAsyncModule } from '../save-to-portfolio/async-modules'

type SaveToPortfolioLinkProps = {
  index: number
}

export default function SaveToPortfolioLink({ index }: SaveToPortfolioLinkProps) {
  const { t } = decodeQueryString()
  const urlTicker = t.split(',')[index]
  const dialog = useDialogState()
  const isVisible = dialog.useState('open')

  const [saveToPortfolioModule] = useAsyncModule({
    ...saveToPortfolioAsyncModule,
    shouldLoadModule: isVisible,
  })
  const SaveToPortfolio = saveToPortfolioModule?.SaveToPortfolio

  return (
    <>
      <span
        onClick={(e) => {
          e.preventDefault() // needed to prevent opening parent link
          window.gtag?.('event', 'click', { event_category: 'save-to-portfolio' })
          dialog.show()
        }}
      >
        Save to Portfolio
      </span>
      <Dialog state={dialog} aria-label="Save to Portfolio" className="w-110">
        {SaveToPortfolio ? (
          <SaveToPortfolio ticker={urlTicker} />
        ) : (
          <div className="flex h-56 items-center justify-center">
            <Spinner />
          </div>
        )}
      </Dialog>
    </>
  )
}
